module.exports = __webpack_public_path__ + "static/media/logo.8a6c91a6.png";